/* Akkaris — en-tête : fixe au défilement, transparence sur l'accueil, ouverture du méga menu au survol.
   Fichier maison, absent de Dawn : à recopier après une mise à jour. */
(() => {
  if (customElements.get('akk-sticky-header')) return;

  class AkkStickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;

      this.stickyType = this.dataset.stickyType || 'none';
      this.alwaysSticky = this.stickyType === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.headerBounds = {};
      this.hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');

      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.updateSolid = this.updateSolid.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPreventReveal = () => (this.preventReveal = true);

      // Transparence : seulement si la 1re section de l'accueil est une Bannière Akkaris
      this.transparent =
        this.dataset.transparent === 'true' && !!document.querySelector('.akk-hero--overlap');
      if (this.dataset.transparent === 'true' && !this.transparent) {
        this.classList.remove('akk-header--transparent');
      }
      document.documentElement.classList.toggle('akk-has-transparent-header', this.transparent);

      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight, { passive: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
        this.resizeObserver.observe(this);
      }

      if (this.stickyType !== 'none') {
        if (this.alwaysSticky) this.header.classList.add('shopify-section-header-sticky');
        this.addEventListener('preventHeaderReveal', this.onPreventReveal);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        const observer = new IntersectionObserver((entries, obs) => {
          this.headerBounds = entries[0].intersectionRect;
          obs.disconnect();
        });
        observer.observe(this.header);
      }

      if (this.transparent) {
        window.addEventListener('scroll', this.updateSolid, { passive: true });
        // l'ouverture d'un <details> (méga menu, tiroir mobile, recherche) rend l'en-tête opaque
        this.addEventListener('toggle', this.updateSolid, true);
        this.updateSolid();
      }

      this.initMega();
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.setHeaderHeight);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('scroll', this.updateSolid);
      document.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('preventHeaderReveal', this.onPreventReveal);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      document.documentElement.classList.remove('akk-has-transparent-header');
    }

    setHeaderHeight() {
      const height = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      document.documentElement.style.setProperty('--akk-header-height', `${height}px`);
    }

    updateSolid() {
      if (!this.transparent) return;
      const scrolled = (window.pageYOffset || document.documentElement.scrollTop) > 8;
      const open =
        !!this.querySelector('details[open]') || this.header.classList.contains('menu-open');
      this.classList.toggle('akk-header--solid', scrolled || open);
    }

    /* ----- Fixe au défilement (même logique que Dawn) ----- */
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const searches = this.querySelectorAll('predictive-search');
      if ([...searches].some((s) => s.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(() => this.hide());
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(() => this.reveal());
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => (this.preventReveal = false), 66);
          requestAnimationFrame(() => this.hide());
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(() => this.reset());
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.alwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeAllMega();
      this.querySelectorAll('details-modal').forEach((modal) => modal.close && modal.close(false));
    }

    reveal() {
      if (this.alwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.alwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    /* ----- Méga menu au survol ----- */
    initMega() {
      this.megaItems = [...this.querySelectorAll('.akk-nav__item--mega')];
      this.megaItems.forEach((item) => {
        const details = item.querySelector('details');
        const summary = details && details.querySelector('summary');
        if (!summary) return;

        item.addEventListener('mouseenter', () => {
          if (!this.hoverQuery.matches) return;
          clearTimeout(item._akkClose);
          clearTimeout(this._akkOpen);
          const anotherOpen = this.megaItems.some((i) => i !== item && i.querySelector('details[open]'));
          // délai court pour éviter les ouvertures involontaires en traversant le menu
          this._akkOpen = setTimeout(() => this.openMega(details, anotherOpen), anotherOpen ? 0 : 90);
        });

        item.addEventListener('mouseleave', () => {
          if (!this.hoverQuery.matches) return;
          clearTimeout(this._akkOpen);
          item._akkClose = setTimeout(() => this.closeMega(details), 160);
        });

        // Souris : un clic sur l'onglet mène à la collection. Clavier/tactile : ouvre le panneau.
        summary.addEventListener('click', (event) => {
          const href = summary.dataset.href;
          if (this.hoverQuery.matches && event.detail > 0 && href) {
            event.preventDefault();
            window.location.href = href;
          }
        });
      });
    }

    openMega(details, instant) {
      this.megaItems.forEach((item) => {
        const other = item.querySelector('details');
        if (other !== details && other.open) this.closeMega(other, true);
      });
      this.classList.toggle('is-mega-instant', !!instant);
      details.open = true;
      details.querySelector('summary').setAttribute('aria-expanded', 'true');
      this.classList.add('is-mega-open');
      this.updateSolid();
    }

    closeMega(details, keepState) {
      if (!details.open) return;
      details.open = false;
      details.querySelector('summary').setAttribute('aria-expanded', 'false');
      if (!keepState && !this.querySelector('.akk-mega[open]')) {
        this.classList.remove('is-mega-open', 'is-mega-instant');
      }
      this.updateSolid();
    }

    closeAllMega() {
      (this.megaItems || []).forEach((item) => this.closeMega(item.querySelector('details')));
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      const open = this.querySelector('.akk-mega[open]');
      if (!open) return;
      this.closeMega(open);
      open.querySelector('summary').focus();
    }
  }

  customElements.define('akk-sticky-header', AkkStickyHeader);
})();
